import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoquateService } from '../../../Dashboard/_services/loquate.service';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AlertService } from '../../../Dashboard/_services/alert.service';

@Component({
    selector: 'app-loquate-finder',
    imports: [FormsModule, MatIconModule],
    templateUrl: './loquate-finder.component.html',
    styleUrl: './loquate-finder.component.css'
})
export class LoquateFinderComponent {
  @Output() addressSelected = new EventEmitter<any>();
  @Input() addressType:string = 'billing';
  postCode: string = '';
  addressSuggestions: any = [];
  showSuggestions:boolean = false;
  searching = false;
  // Shown under the box when Loqate can't help (out of credit, error, offline).
  notice = '';
  constructor(
    private locateService: LoquateService,
    private alertService: AlertService
  ) {}
  onFindYourAddress() {
    this.addressSuggestions = [];
    this.notice = '';
    if (this.postCode.trim() !== '') {
      this.getAddressSuggestions();
    }
  }
  onGetAddressDetails(addressId:string, label = '') {
    this.getAddressDetails(addressId, label);
  }

  // Loqate reports problems either as an HTTP error or as an Items[0].Error
  // (e.g. Error 3 = account out of credit). Either way: say so, and keep the
  // postcode so the address can be typed in.
  private lookupUnavailable() {
    this.addressSuggestions = [];
    this.showSuggestions = false;
    this.notice = 'Address lookup is unavailable right now - please type the address in below.';
  }

  private fallback(label: string) {
    this.lookupUnavailable();
    this.notice = "Couldn't fetch the full address - the postcode has been added, please fill in the rest below.";
    this.addressSelected.emit({
      addressData: { address1: label || '', address2: '', city: '', country: '', postCode: this.postCode.toUpperCase().trim() },
      type: this.addressType,
    });
  }

  private getAddressSuggestions() {
    this.searching = true;
    this.locateService.getAddressessForPostcode(this.postCode.trim()).subscribe({
      next: (response) => {
        this.searching = false;
        const items = response?.Items || [];
        if (items[0]?.Error) return this.lookupUnavailable();
        this.addressSuggestions = items;
        this.showSuggestions = true;
      },
      error: () => {
        this.searching = false;
        this.lookupUnavailable();
      },
    });
  }
  private getAddressDetails(addressId: string, label = '') {
    this.locateService.getAddressDetails(addressId).subscribe({
      next: (response) => {
        const items = response?.Items || [];
        if (!items.length || items[0]?.Error) return this.fallback(label);
        let addressData = {
            address1: "",
            address2: "",
            city: "",
            country: "",
            postCode: "",
        };
        items.forEach((addrs:any) => {
          if(addrs.Line1) addressData.address1 = addrs.Line1;
          if(addrs.Line2) addressData.address2 = addrs.Line2;
          if(addrs.City) addressData.city = addrs.City;
          if(addrs.Province) addressData.country = addrs.Province;
          if(addrs.PostalCode) addressData.postCode = addrs.PostalCode;
        });
        this.addressSuggestions = [];
        this.showSuggestions = false;
        this.addressSelected.emit({
          addressData: addressData,
          type: this.addressType
        });
        // Keep a copy in our own address book (only full addresses Loqate returned).
        if (addressData.address1 && addressData.postCode) {
          this.locateService.saveAddress({
            address1: addressData.address1,
            address2: addressData.address2,
            city: addressData.city,
            county: addressData.country, // Loqate's "Province" - the county
            postalcode: addressData.postCode,
          }).subscribe({ error: () => {} });
        }
      },
      error: () => this.fallback(label),
    });
  }
}
